import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TicketNote } from 'src/app/core/models/appointment-note.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';

@Component({
	selector: 'app-appointment-notes',
	templateUrl: './appointment-notes.component.html',
	styleUrls: ['./appointment-notes.component.scss'],
})

export class AppointmentNotesComponent {

	pageTitle = 'Notes';

	noteForm: FormGroup;
	ticketNote = {} as TicketNote;
	activeAppointmentSub: Subscription;
	isValidFormSubmitted: boolean;

	constructor(
		private appointmentService: AppointmentService,
		private toastController: ToastController,
		private alertController: AlertController,
		private formBuilder: FormBuilder
	) { }

	ionViewWillEnter() {
		this.noteForm = this.formBuilder.group({
			subject: ['', Validators.required],
			note: ['', Validators.compose([Validators.required, Validators.minLength(5)])]
		});

		this.activeAppointmentSub = this.appointmentService.activeAppointment$
			.subscribe(newAppointment => {
				this.ticketNote.ticketId = newAppointment?.ticketId;
			});
	}

	ionViewWillLeave() {
		this.activeAppointmentSub.unsubscribe();
	}

	async onSaveNote() {
		this.isValidFormSubmitted = false;
		this.trimWhitespace();

		if (this.noteForm.invalid) {
			await this.toastNoteInvalid();
			return;
		}
		this.isValidFormSubmitted = true;

		this.addTicketNote();
		this.toastNoteSaved();
		this.noteForm.reset();
	}

	private addTicketNote() {
		this.ticketNote.subject = this.noteForm.value.subject;
		this.ticketNote.note = this.noteForm.value.note;
		this.ticketNote.timestamp = moment().toISOString(true);
		this.appointmentService.addTicketNote(this.ticketNote);
	}

	private async toastNoteSaved(): Promise<void> {
		const statusChangeToast = await this.toastController.create({
			message: `Note saved.`,
			duration: 3000,
			position: 'top',
			color: 'success',
			buttons: ['Dismiss'],
		});

		await statusChangeToast.present();
	}

	private async toastNoteInvalid(): Promise<void> {
		const statusChangeToast = await this.alertController.create({
			header: 'Error',
			message: 'Please review required fields.',
			buttons: ['OK'],
		});

		await statusChangeToast.present();
	}

	private trimWhitespace() {
		for (const i in this.noteForm.controls) {
			if (!this.noteForm.controls.hasOwnProperty(i)) {
				continue;
			}

			this.noteForm.controls[i].setValue(this.noteForm.controls[i].value.trim());
			this.noteForm.controls[i].markAsTouched();
		}
	}
}
